import { t } from './i18n.js';

/**
 * A story's state as a small badge: a draft (autosaved while the journalist writes), finalised ("ready", the
 * journalist is done), approved (the editor-in-chief signed it off). The compact form fits a grid cell.
 */
const WORDS = {
  draft: { full: 'statusDraft', short: 'statusDraftShort' },
  ready: { full: 'statusReady', short: 'statusReadyShort' },
  approved: { full: 'statusApproved', short: 'statusApprovedShort' },
} as const;

export function StoryStatusBadge({ status, compact }: { status: string | null | undefined; compact?: boolean }) {
  if (!status || !(status in WORDS)) return null;
  const w = WORDS[status as keyof typeof WORDS];
  return (
    <span className={`sbadge ${status}`} title={t(w.full)}>
      {t(compact ? w.short : w.full)}
    </span>
  );
}
